import { HighlightText } from "@/components/MedicalChronology/HighlightText";
import { FileText } from "lucide-react";

import { formatCitationPages, getCitationFileLabel } from "../utils/visitFormatting";
import { VisitCitationEmpty } from "./VisitCitationEmpty";
import type { VisitCitationListProps } from "./types";
import { getCitationKey } from "./utils";

export const VisitCitationStackedList = ({
  citations,
  fileMapping,
  onCitationClick,
  highlightQuery,
}: VisitCitationListProps) => {
  if (citations.length === 0) return <VisitCitationEmpty />;

  return (
    <ul className="flex flex-col gap-2">
      {citations.map((citation, index) => (
        <li key={getCitationKey(citation, index)}>
          <button
            type="button"
            onClick={() => onCitationClick(citation)}
            className="group flex flex-col gap-0.5 text-left focus-visible:shadow-focus-inset focus-visible:outline-none"
          >
            <span className="flex items-center gap-1.5 text-xs font-semibold text-neutral-900 transition-colors group-hover:text-primary">
              <FileText size={14} strokeWidth={2.5} aria-hidden="true" />
              {formatCitationPages(citation)}
            </span>
            <span className="max-w-[200px] truncate pl-5 text-2xs text-neutral-500">
              <HighlightText
                highlightQuery={highlightQuery}
                text={getCitationFileLabel(citation, fileMapping)}
              />
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
};
